/**
 * DownloadData slot component.
 *
 * @deprecated Use chart-specific DownloadCSV slot instead (e.g. \<CategoricalBarChart.DownloadCSV /\>).
 */
export const DownloadData = () => null;

// oxlint-disable-next-line typescript/no-deprecated
DownloadData['displayName'] = 'ChartInteractions.DownloadData';
